import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from 'config/queryClient';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from 'routes/AppRoutes';

const App = () => (
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
            <AppRoutes />
            <ReactQueryDevtools />
        </BrowserRouter>
    </QueryClientProvider>
);

export default App;
